/* @flow */
import React from 'react';
import Device from 'entities/Device';
import UserActions from 'user/UserActions';
import CurrentUser from 'auth/CurrentUser';
import ToastActions from 'actions/ToastActions';
import Link from 'components/Link.jsx';

/* Component to resend a confirmation email:
 *
 * if (user.getUnconfirmedEmail()) {
 *  var resent = <ResentConfirmationEmail>Click me!</ResentConfirmationEmail>;
 * }
 *
 */
class ResentConfirmationEmail extends React.Component {
  static propTypes = {
    /* silences all the toast, default false */
    silent: React.PropTypes.bool,
    /* called if API returned 2xx */
    onSuccess: React.PropTypes.func,
    /* called if API did not return 2xx */
    onError: React.PropTypes.func,
    email: React.PropTypes.instanceOf(Device),
  };

  static defaultProps = {
    silent: false,
  };

  resendConfirmation = () => {
    const success = () => {
      const email = (this.props.email && this.props.email.getEndpoint())
        || CurrentUser.getUser().getUnconfirmedEmail();

      if (!this.props.silent) {
        ToastActions.showSuccessToast(`Sent confirmation link to ${email}`);
      }

      if (this.props.onSuccess) {
        this.props.onSuccess();
      }
    };

    const onFailure = () => {
      if (!this.props.silent) {
        ToastActions.showDefaultErrorToast();
      }

      if (this.props.onError) {
        this.props.onError();
      }
    };

    if (this.props.email) {
      this.props.email
        .resendConfirmationEmail()
        .then(success, onFailure);
    } else {
      UserActions
        .requestConfirmation()
        .then(success, onFailure);
    }
  };

  render() {
    return (
      <Link
        onClick={this.resendConfirmation}
        {...this.props}>
        {this.props.children}
      </Link>
    );
  }
}

export default ResentConfirmationEmail;



// WEBPACK FOOTER //
// ./src/settings/components/ResentConfirmationEmail.jsx